module.exports = __webpack_public_path__ + "img/check-icon.994d10cf.svg";